import { useMap } from '@vis.gl/react-google-maps'
import { RefObject, useEffect } from 'react'

interface UseMapScrollOutsideProps {
  ref: RefObject<HTMLElement | null> | RefObject<HTMLElement | null>[]
  callback: () => void
  breakpoint?: number
}

const useMapScrollOutside = ({
  ref,
  callback,
  breakpoint
}: UseMapScrollOutsideProps) => {
  const map = useMap()

  useEffect(() => {
    const handleWheel = (e: WheelEvent | Event) => {
      const isRefArray = Array.isArray(ref)
      const isOutsideRef = isRefArray
        ? !ref.filter(
            ref => ref?.current && ref.current.contains(e.target as Node)
          ).length
        : ref?.current && !ref.current.contains(e.target as Node)

      const isInsideMap = map?.getDiv()?.contains(e.target as Node)

      if (isOutsideRef && isInsideMap) {
        callback()
      }
    }

    if ((breakpoint && window.innerWidth >= breakpoint) || !breakpoint) {
      document.addEventListener('wheel', handleWheel)
    }

    return () => {
      document.removeEventListener('wheel', handleWheel)
    }
  }, [ref, callback, breakpoint, map])
}

export { useMapScrollOutside }
export type { UseMapScrollOutsideProps }
